import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutation'
import actions from './action'

Vue.use(Vuex);

const Store = new Vuex.Store({
  state,
  mutations,
  actions,
})

export default Store;



// WEBPACK FOOTER //
// ./src/vuex/index.js